import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation, EffectCoverflow, Autoplay } from 'swiper/modules';
import { IoIosArrowDroprightCircle, IoIosArrowDropleftCircle } from "react-icons/io";

const ClientsSwiper = ({ testimonials }) => {
    return (
        <>
            <div className='px-4 py-6 rounded-2xl'>
                <div data-aos="fade-down" data-aos-easing="ease-in-out" className='relative swiper2'>
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        autoplay={{ delay: 800, disableOnInteraction: true }}
                        centeredSlides={true}
                        navigation={{ nextEl: '.arrow-right2', prevEl: '.arrow-left2' }}
                        loop={true}
                        speed={1000}
                        spaceBetween={20}
                        slidesPerView={'auto'}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: false,
                        }}
                        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
                        className='w-[100%] h-[220px]'
                    >
                        {testimonials && testimonials.map((testimonial, index) => (
                            <SwiperSlide key={index} className='w-[100%]'>
                                <div dir='rtl' className='max-w-[300px] sm:max-w-[450px] items-center mx-auto mt-[20px]'>
                                    <p className={`text-clientsSwiper_textColor font-medium mx-auto text-center ${testimonial.text.length > 200 ? 'text-xs' : ''}`}>
                                        "{testimonial.text}"
                                    </p>
                                    <p className='text-clientsSwiper_authorColor font-bold mt-2 text-sm text-center'>
                                        {testimonial.author}
                                    </p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button className='arrow-left2 arrow m-2'>
                        <IoIosArrowDropleftCircle size={35} className='text-clientsSwiper_iconColor rounded-full hover:opacity-80' />
                    </button>
                    <button className='arrow-right2 arrow m-2'>
                        <IoIosArrowDroprightCircle size={35} className='text-clientsSwiper_iconColor rounded-full hover:opacity-80' />
                    </button>
                </div>
            </div>
        </>
    );
};

export default ClientsSwiper;
